import { GetAudioDialogLinesBulkParams, GetAudioDialogLinesParams } from "../types/requestInputs";
import { AudioAIDialogLine } from "../types/types";
import { fetchAPI } from "./utils";

export const getAudioDialogLines = async ({
    token,
    audioId,
}: GetAudioDialogLinesParams): Promise<AudioAIDialogLine[]> => {
    const data = await fetchAPI<AudioAIDialogLine[]>(`/audio/${audioId}/dialog-lines`, "GET", undefined, token);
    return data || [];
};

export const getAudioDialogLinesBulk = async ({
    token,
    audioIds,
}: GetAudioDialogLinesBulkParams): Promise<Record<string, AudioAIDialogLine[]>> => {
    const data = await fetchAPI<Record<string, AudioAIDialogLine[]>>(
        "/audio/dialog-lines/bulk",
        "POST",
        { audioIds },
        token,
    );
    return data || {};
};
